<script setup>
import GenerateNewHoldbacksComponent from "@/Components/HoldBacks/GenerateNewHoldbacksComponent.vue";
import {Permissions} from "@/Utils/Permissions";
import {useRoute} from "vue-router";

const route = useRoute();
</script>

<template>
  <v-row>
    <v-col cols="12">
      <GenerateNewHoldbacksComponent v-if="Permissions.checkPermissions(['holdbacks.generate-new'])" :payPeriodId="route.params.payPeriodId"/>
    </v-col>
  </v-row>
</template>

<style scoped>

</style>